import {Address} from "@/interfaces/entities/Address";

export interface User {
    firstName: string; // "Toni",
    lastName: string; // "Frotscher"
    email: string; // "t.frotscher@tdsoftware.de"
    companyName: string;
    taxId: string;
    addresses: Array<Address>;
}

export enum Roles {
    ADMIN = "ROLE_RESELLER_ADMIN",
    SUPPORT = "ROLE_RESELLER_SUPPORT",
    BILLING = "ROLE_RESELLER_BILLING",
    DEVELOPER = "ROLE_RESELLER_DEVELOPER",
    SALES = "ROLE_RESELLER_SALES"
}
